import {
  STREAM_MODE_STORAGE_KEY,
  STREAM_MODE_VIDEO,
} from '@fec/frontend/snowflakes/radio/radio-live-player/radio-live-player';

import ClientStorage from '@fec/frontend/foundation/client/storage';

export function init() {
  const button = document.querySelector(
    '.js-radio-content-header-visualradioLink',
  );

  /*
   * Clicks on the Webcam-Button should open the Radio Live Player in video-Mode. Always.
   */
  button?.addEventListener('click', () => {
    ClientStorage.setItem(STREAM_MODE_STORAGE_KEY, STREAM_MODE_VIDEO);
  });
}
